import { Offer } from 'app/services/offers/offer.model';

export class GetDealOffers {
	static readonly type = '[Offer] GetDealOffers';
	constructor(public borrowerId: number) {}
}

export class DeleteOffer {
	static readonly type = '[Offer] DeleteOffer';
	constructor(public offerId: number) {}
}

export class UpdateOffer {
	static readonly type = '[Offer] UpdateOffer';
	constructor(public offerId: number, public updates: any) {}
}

export class CreateOffer {
	static readonly type = '[Offer] CreateOffer';
	constructor(public offer: Offer) {}
}

export class PublishOffer {
	static readonly type = '[Offer] PublishOffer';
	constructor(public offerId: number, public userId: number, public publishedToBorrower: number) {}
}

export class ToggleOffer {
	static readonly type = '[Offer] ToggleOffer';
	constructor(public offerId: number) {}
}

export class ClearOfferStore {
	static readonly type = '[Offer] ClearOfferStore';
	constructor() {}
}

export class ClearOfferError {
	static readonly type = '[Offer] ClearOfferError';
	constructor() {}
}

